import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import Table from 'components/new_ui/Table';
import Invite from 'components/Managers/Members/Views/Invite/Index';
import { useContext } from 'components/Managers/Invite/Context';
import columns from './columns';
import NoData from './NoData';

export default function Index({ setView }) {
  const { dispatch, actions, state } = useContext();
  const [invitedList, setInvitedList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const closeInviteModal = () => {
    setInvitedList([]);
  };

  const sentCallback = () => {
    actions.load(dispatch);
    setView('invited');
  };

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  return (
    <div className="content">
      <section>
        <h1 className="mb-3">Invite Members</h1>

        <p>
          We look forward to helping your members reach their goals in the most efficient
          way possible. Invite them to LeggUP today!
        </p>
      </section>

      <section className="pt-2">
        <Table
          title=" "
          columns={columns}
          data={state.members || []}
          loading={state.members == null}
          rowActions={[]}
          groupActions={[]}
          selectableRows
          noData={<NoData />}
          afterSelect={(rows) => setSelectedRows(rows)}
          selectableRowSelected={(row) => row.attributes.possible_invite}
          selectableRowDisabled={(row) => !row.attributes.possible_invite}
        />
      </section>

      {state.members && state.members.length > 0 && (
        <>
          <footer>
            <Button
              onClick={() => setInvitedList(state.members.filter((item) => selectedRows.includes(item.id)))}
            >
              Invite
            </Button>
          </footer>

          <Invite members={invitedList} cancelCallback={closeInviteModal} sentCallback={sentCallback} />
        </>
      )}
    </div>
  );
}

Index.propTypes = {
  setView: PropTypes.func.isRequired,
};
